<template>
  <section>
    <div
      class="w-full w-min-[360px] flex items-center justify-between p-4 sm:p-8 bg-h-primary-100 rounded-lg"
    >
      <div class="flex gap-8 items-center w-[80%]">
        <!-- <MagicSvg
          id="custom-banner-svg"
          :path="image"
          color="text-h-primary-500 stroke-h-primary-50"
        /> -->
        <div id="headers" class="flex flex-col gap-3">
          <h3>
            {{ $t("labels.generic", { pt: title, en: titleEN }) }}
          </h3>
          <p>
            {{
              $t("labels.generic", {
                pt: subtitle,
                en: subtitleEN,
              })
            }}
          </p>
        </div>
      </div>
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "banner",
  props: {
    image: {
      type: String,
      default: "",
    },
    title: String,
    titleEN: String,
    subtitle: String,
    subtitleEN: String,
    hiddenIcon: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss">
#custom-banner-svg {
  svg,
  path {
    width: 100%;
    height: 90px;
    @apply fill-current #{!important};
  }
}
</style>
